import { Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { formatSignedPercentage } from '../../../../../../utils/formatSignedPercentage'
import { EMPTY_VALUE_PLACEHOLDER } from '../../../../constants/emptyValuePlaceholder'

interface SupplierBalanceVariancePercentageProps {
  value: number | null
}

export const SupplierBalanceVariancePercentage = ({ value }: SupplierBalanceVariancePercentageProps): ReactElement => {
  if (value === null) {
    return (
      <Text as="span" inherit>
        {EMPTY_VALUE_PLACEHOLDER}
      </Text>
    )
  }
  return (
    <Text as="span" inherit color={value < 0 ? Color.Red700 : undefined}>
      {formatSignedPercentage(value)}
    </Text>
  )
}
